import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
    },
  })
);

export const VerticalLinearStepper = ({
  active,
  steps
}: {
  active: number,
  steps: string[],
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Stepper activeStep={active} orientation="vertical" style={{
        padding: '24px 0'
      }}>
        {steps.map((label, index) => (
          <Step key={label} completed={index < active}>
            <StepLabel>
              <span style={{
                fontSize: 18,
                fontWeight: index == active ? 'bold' : 'normal'
              }}>{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};